export default __webpack_public_path__ + "static/media/GWP.c2640767.svg";